import { createSelector } from 'reselect';
import { ROUTE_SSO } from '../routeActions';

import { selectPayload, selectType } from '../location/selectors';

export const selectPage = createSelector([selectPayload], (params) =>
  params.get('page')
);

export const selectAction = createSelector([selectPayload], (params) =>
  params.get('action')
);

export const selectCourseId = createSelector([selectPayload], (params) =>
  params.get('courseId')
);

export const selectIsSSOLoginMode = createSelector([selectType], (type) => {
  return type === ROUTE_SSO;
});
